import React from "react";
import { CategoryProvider, useCategory } from "./categoryContext";
import { CategoryFilterList } from "./categoryFilterList";
import { BlogPostGrid } from "@components/blog/blogPostGrid";

const Category = ({ children }) => {
  return <CategoryProvider>{children}</CategoryProvider>;
};

Category.FilterList = CategoryFilterList;

Category.BlogPostGrid = ({ posts, ads, children, ...props }) => {
  const { filterPostsByCategory, isSelectedCategory, defaultCategory } = useCategory();
  const filteredPosts = filterPostsByCategory(posts);

  // TODO: Probably a better way to do this. I'm tired.
  let items = filteredPosts;
  if (isSelectedCategory(defaultCategory) && ads && ads.length > 0) {
    items = posts.reduce((acc, post) => {
      acc.push(post);
      if (acc.length === 3) {
        acc.splice(3, 0, ads[0]);
      } else if (acc.length === 7 && ads.length > 1) {
        acc.splice(7, 0, ads[1]);
      }
      return acc;
    }, []);
  }

  return (
    <BlogPostGrid items={items} {...props}>
      {children}
    </BlogPostGrid>
  );
};

export { Category };
